<script setup>
import { computed } from 'vue'
import { useStore } from '@composables/use-store'

const ALIGN_CLASSES = {
    center: 'genre-pills-center',
    end: 'genre-pills-end',
}

const props = defineProps({
    genres: {
        type: Array,
        default: () => [],
    },
    align: {
        type: String,
        default: 'auto', // auto, center, end
    },
})

const store = useStore()

const alignClass = computed(() => ALIGN_CLASSES[props.align])

const extendedGenres = computed(() =>
    props.genres.map(genre => {
        const known = store.state.genres.genres.find(candidate => candidate.name === genre)
        return known || { name: genre, slug: genre }
    })
)
</script>

<template>
    <div :class="['genre-pills', alignClass]">
        <span
            v-for="genre in extendedGenres"
            :key="genre.slug"
            class="genre"
        >
            <router-link :to="{ name: 'genre', params: { slug: genre.slug } }">
                <BaseButton
                    button-type="tagSecondary"
                    size="small"
                    @click="() => {}"
                >
                    <slot>
                        {{ genre.name }}
                    </slot>
                </BaseButton>
            </router-link>
        </span>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.genre-pills {
    display: flex;
    flex-wrap: wrap;
    gap: $s-s;
    justify-content: center;
    width: 100%;
    margin: 0 auto;

    @include tablet {
        justify-content: flex-start;
    }

    // Declared after the breakpoint so an explicit alignment holds at every width.
    &-center {
        justify-content: center;
    }

    &-end {
        justify-content: flex-end;
    }
}
</style>
